import React from 'react'
import { useSelector } from 'react-redux'

import { ReactComponent as UserPlaceholder } from '../../../../../assets/icons/user-placeholder.svg'
import { ReactComponent as ArrowIcon } from '../../../../../assets/icons/arrow.svg'

import UserNav from './UserNav'
import Dropdown from '../../../../../components/Dropdown'

import { getCurrentUserSelector } from '../../../../../modules/selectors/app'

import useStyles from './style'

function UserMenu() {
  const classes = useStyles()

  const { full_name: fullName, email } = useSelector(getCurrentUserSelector)

  return (
    <Dropdown
      closeOnInsideClick
      placement="bottom-end"
      offset={[0, 10]}
      triggerElement={
        <div className={classes.userMenuContainer}>
          <UserPlaceholder />
          {fullName && <span>{fullName}</span>}
          <ArrowIcon className={classes.arrowIcon} />
        </div>
      }
    >
      <div className={classes.userDropdown}>
        {fullName && <div className={classes.userName}>{fullName}</div>}
        {email && <div className={classes.userEmail}>{email}</div>}
        <div className={classes.userNavWrapper}>
          <UserNav />
        </div>
      </div>
    </Dropdown>
  )
}

export default UserMenu
